import styled from '@emotion/styled';
import { ellipsis } from '../../../common/emotion';

export const TooltipText = styled.div`
  ${ellipsis()};
  width: 100%;
`;
